import api from "../api";
import {ElMessage} from "element-plus";

export default {
    namespaced: true,
    state: {
        loading: false,
        properties: {data: [], current_page: 1, total: 0, per_page: 10},
        property: [], errors: {
            data: {
                errors: {
                    project_id: [],
                    property_category_id: [],
                    property_type_id: [],
                    description: [],
                    price: [],
                    minimum_deposit: [],
                    monthly_installment: [],
                    no_of_units: [],
                    sold_out: [],
                    area: []
                }
            }
        },
        all_properties: {},
        erits: {data: [], current_page: 1, total: 0, per_page: 10},
        has_errors: false,
        session_property: localStorage.getItem('session_property') ?? null,
    }, getters: {
        property: state => state.property,
        properties: state => state.properties,
        all_properties: state => state.all_properties,
        errors: state => state.errors,
        erits: state => state.erits,
        has_errors: state => state.has_errors,
        loading: state => state.loading,
        session_property: state => state.session_property
    }, mutations: {
        activateLoading(state, data) {
            state.loading = data
        },
        setProperties(state, data) {
            state.properties = data;
        },
        setErits(state, data) {
            state.erits = data;
        },
        setPropertiesAll(state, data) {
            state.all_properties = data;
        },
        setSessionProperty(state, data) {
            state.session_property = data;
        },
        setProperty(state, data) {
            state.property = data;
        },
        setErrors(state, errors) {
            state.errors = errors
        },
        setLoading(state, value) {
            state.loading = value
        },
        hasErrors(state, val) {
            state.has_errors = val
            if (!val) {
                state.errors = {
                    data: {
                        errors: {
                            project_id: [],
                            property_category_id: [],
                            property_type_id: [],
                            description: [],
                            price: [],
                            minimum_deposit: [],
                            monthly_installment: [],
                            no_of_units: [],
                            sold_out: [],
                            area: []
                        }
                    }
                };
            }
        }
    }, actions: {
        async getProperties({commit}, filters) {
            try {
                commit('activateLoading', 'property/list', {root: true});
                const response = await api.getProperties(filters);
                commit('setProperties', response);
                commit('deactivateLoading', 'property/list', {root: true});
            } catch (e) {
                ElMessage.error({
                    'message': e?.response?.data?.message || "There was a problem getting properties."
                })
            }
        },
        async getUserProperties({commit}, filters) {
            try {
                commit('setLoading', true)
                commit('activateLoading', 'property/list', {root: true});
                const response = await api.getUserProperties(filters);
                commit('setProperties', response);
                commit('setLoading', false);
            } catch (e) {
                commit('setLoading', false)
                ElMessage.error({
                    'message': e?.response?.data?.message || "There was a problem fetching properties."
                })
            }
        },

        async generatePNR({commit}, filters) {
            try {
                commit('setLoading', true)
                commit('activateLoading', 'property/list', {root: true});
                await api.generatePNR(filters);
                commit('setLoading', false);
            } catch (e) {
                commit('setLoading', false)
                commit('hasErrors', true)
                commit('setErrors', e.response)
                ElMessage.error({
                    'message': e?.response?.data?.message || "There was a problem generating PNR for property."
                })
            }
        },
        async getErits({commit}, filters) {
            try {
                commit('setLoading', true)
                commit('activateLoading', 'property/list', {root: true});
                const response = await api.getErits(filters);
                commit('setErits', response);
                commit('setLoading', false);
            } catch (e) {
                commit('setLoading', false)
                ElMessage.error({
                    'message': e?.response?.data?.message || "There was a problem fetching e-rits."
                })
            }
        },
        async getUserAllProperties({commit}, filters) {
            try {
                commit('setLoading', true)
                commit('activateLoading', 'property/list', {root: true});
                const response = await api.getUserProperties(filters);
                commit('setPropertiesAll', response);
                commit('setLoading', false);
            } catch (e) {
                commit('setLoading', false)
                ElMessage.error({
                    'message': e?.response?.data?.message || "Property details updated successfully."
                })
            }
        },
        async getProperty({commit}, id) {
            try {
                commit('activateLoading', 'property/list', {root: true});
                const response = await api.getProperty(id);
                commit('setProperty', response.data);
                commit('deactivateLoading', 'property/list', {root: true});
            } catch (e) {
                ElMessage.error({
                    'message': e?.response?.data?.message || "There was a problem getting specified property."
                })
            }
        },

        async createProperties({dispatch, commit}, data) {
            try {
                commit('hasErrors', false)
                commit('setLoading', true)
                const response = await api.createProperty(data);
                commit('setProperty', response)
                ElMessage.success({
                    message: "Successfully Added property!",
                    offset: 300
                })
            } catch (e) {
                commit('hasErrors', true)
                commit('setErrors', e.response)
                ElMessage.error({
                    message: "Error creating property!",
                    offset: 100
                })
                commit('setLoading', false)
            }
        },

        async createOnboarding({dispatch, commit}, data) {
            try {
                commit('hasErrors', false)
                commit('setLoading', true)
                await api.createOnboarding(data);
                ElMessage.success({
                    message: "Successfully onboarded your properties!",
                    offset: 300
                })
            } catch (e) {
                commit('hasErrors', true)
                commit('setErrors', e.response)
                ElMessage.error({
                    message: "There was a problem onboarding your properties!",
                    offset: 100
                })
                commit('setLoading', false)
            }
        },

        async getOnboardingClient({dispatch, commit}, data) {
            try {
                commit('hasErrors', false)
                commit('setLoading', true)
                await api.getOnboardingClient(data);
            } catch (e) {
                commit('hasErrors', true)
                commit('setErrors', e.response)
                ElMessage.error({
                    message: "There was a problem getting your client. Please try again later.",
                    offset: 100
                })
                commit('setLoading', false)
            }
        },

        async saveUserProperties({dispatch, commit}, data) {
            try {
                commit('hasErrors', false)
                commit('setLoading', true)
                await api.assignProperty(data);
                ElMessage.success({
                    message: "Assigned Property!",
                    offset: 300
                })
            } catch (e) {
                commit('hasErrors', true)
                commit('setErrors', e.response)
                ElMessage.error({
                    message: "Error assigning property!",
                    offset: 100
                })
                commit('setLoading', false)
            }
        },

        async editProperty({dispatch, commit}, data) {
            try {
                await api.editProperty(data);
                dispatch('getProperties', data.id);
                ElMessage.success({
                    'message': "Property updated successfully."
                })
            } catch (e) {
                commit('hasErrors', true)
                commit('setErrors', e.response)
                ElMessage.error({
                    'message': e?.response?.data?.message || "There was a problem editing specified property."
                })

            }
        },

        async editPropertyFormData({dispatch, commit}, data) {
            try {
                commit('setLoading', true)
                await api.editPropertyFormData(data);
                dispatch('getProperties', data.id);
                ElMessage.success({
                    'message': "Property details updated successfully."
                })
                commit('setLoading', false)
            } catch (e) {
                commit('hasErrors', true)
                commit('setErrors', e.response)
                ElMessage.error({
                    'message': "There was a problem updating property details. Please try again later."
                })
                commit('setLoading', false)
            }
        },

        async deleteProperty({dispatch}, data) {
            try {
                await api.deleteProperty(data);
                dispatch('getProperties', data.id);
                ElMessage.success({
                    'message': "Property removed successfully."
                })
            } catch (e) {
                ElMessage.error({
                    'message': "Error removing property."
                })
            }
        },

        async exportPropertiesReport({commit}, {filters, format}) {
            try {
                commit('setLoading', true);
                let fileName = new Date().toISOString().slice(0, 10).replaceAll("-", "_") + "_" + new Date().toLocaleTimeString();
                const response = await api.exportPropertiesReport({...filters, format});
                const url = window.URL.createObjectURL(new Blob([response]))
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', 'Properties_Report_' + fileName + '.' + format);
                document.body.appendChild(link);
                link.click();
                commit('setLoading', false);
            } catch (e) {
                commit('setLoading', false);
                if (e.response.status === 422) {
                    ElMessage.error("Whoops! You have insufficient permissions to perform this action.");
                } else {
                    ElMessage.error(e.response.data.message);
                }
            }
        },

    }
}
